import { ChevronRight } from "lucide-react";
import {
  InfiniteListBase,
  useGetIdentity,
  useListContext,
  useTranslate,
} from "ra-core";
import { Link } from "react-router";

import { MobileContent } from "../layout/MobileContent";
import MobileHeader from "../layout/MobileHeader";
import { ChoiceDot } from "../misc/ChoiceBadge";
import { InfinitePagination } from "../misc/InfinitePagination";
import { useConfigurationContext } from "../root/ConfigurationContext";
import type { Company } from "../types";
import { CompanyAvatar } from "./CompanyAvatar";

/** Mobile list of companies; the header's global search finds one by name. */
export const CompanyListMobile = () => {
  const { identity } = useGetIdentity();
  if (!identity) return null;
  return (
    <InfiniteListBase perPage={25} sort={{ field: "name", order: "ASC" }}>
      <CompanyListLayoutMobile />
    </InfiniteListBase>
  );
};

const CompanyListLayoutMobile = () => {
  const translate = useTranslate();
  const { data, error } = useListContext<Company>();
  const { customerStatuses, prospectStates } = useConfigurationContext();

  return (
    <>
      <MobileHeader showRefresh>
        <h1 className="text-xl font-semibold">
          {translate("resources.companies.name", { smart_count: 2 })}
        </h1>
      </MobileHeader>
      <MobileContent>
        <ul className="divide-y">
          {data?.map((company) => {
            const status = customerStatuses.find(
              (item) => item.value === company.customer_status,
            );
            const state = prospectStates.find(
              (item) => item.value === company.prospect_state,
            );
            return (
              <li key={company.id}>
                <Link
                  to={`/companies/${company.id}/show`}
                  className="flex items-center gap-3 py-3"
                >
                  <CompanyAvatar record={company} />
                  <div className="flex-1 min-w-0">
                    <div className="font-medium truncate">{company.name}</div>
                    <div className="flex flex-wrap gap-x-3 text-sm text-muted-foreground">
                      {status ? <ChoiceDot choice={status} /> : null}
                      {state ? <ChoiceDot choice={state} /> : null}
                    </div>
                  </div>
                  <ChevronRight className="size-4 text-muted-foreground" />
                </Link>
              </li>
            );
          })}
        </ul>
        {!error && (
          <div className="flex justify-center">
            <InfinitePagination />
          </div>
        )}
      </MobileContent>
    </>
  );
};
